<template>
  <div class="rents-quantities">
    <div class="row">
      <div class="col-xs-6 col-md-2">
        <button @click="navigate(1)" :class="{ active: this.statusId == 1 }" class="text-center btn btn-default btn-block status-1">
          <strong v-if="rentsStatus[1] != null">{{ rentsStatus[1] }}</strong>
          <strong v-else=""><i class="fa fa-fw fa-lg fa-spin fa-spinner"></i></strong>
          <br>
          <small>NOVAS</small>
        </button>
      </div>
      <div class="col-xs-6 col-md-2">
        <button @click="navigate(3)" :class="{ active: this.statusId == 3 }" class="text-center btn btn-default btn-block status-3">
          <strong v-if="rentsStatus[3] != null">{{ rentsStatus[3] }}</strong>
          <strong v-else=""><i class="fa fa-fw fa-lg fa-spin fa-spinner"></i></strong>
          <br>
          <small>CONFIRMADAS</small>
        </button>
      </div>
      <div class="col-xs-6 col-md-2">
        <button @click="navigate(4)" :class="{ active: this.statusId == 4 }" class="text-center btn btn-default btn-block status-4">
          <strong v-if="rentsStatus[4] != null">{{ rentsStatus[4] }}</strong>
          <strong v-else=""><i class="fa fa-fw fa-lg fa-spin fa-spinner"></i></strong>
          <br>
          <small>TRANSPORTE</small>
        </button>
      </div>
      <div class="col-xs-6 col-md-2">
        <button @click="navigate(5)" :class="{ active: this.statusId == 5 }" class="text-center btn btn-default btn-block status-5">
          <strong v-if="rentsStatus[5] != null">{{ rentsStatus[5] }}</strong>
          <strong v-else=""><i class="fa fa-fw fa-lg fa-spin fa-spinner"></i></strong>
          <br>
          <small>INICIADAS</small>
        </button>
      </div>
      <div class="col-xs-6 col-md-2">
        <button @click="navigate(6)" :class="{ active: this.statusId == 6 }" class="text-center btn btn-default btn-block status-6">
          <strong v-if="rentsStatus[6] != null">{{ rentsStatus[6] }}</strong>
          <strong v-else=""><i class="fa fa-fw fa-lg fa-spin fa-spinner"></i></strong>
          <br>
          <small>FINALIZADAS</small>
        </button>
      </div>
      <div class="col-xs-6 col-md-2">
        <button @click="navigate(7)" :class="{ active: this.statusId == 7 }" class="text-center btn btn-default btn-block status-7">
          <strong v-if="rentsStatus[7] != null">{{ rentsStatus[7] }}</strong>
          <strong v-else=""><i class="fa fa-fw fa-lg fa-spin fa-spinner"></i></strong>
          <br>
          <small>PENDENTES</small>
        </button>
      </div>
    </div>
    <audio ref="newRents" :src="cdn('sound.mp3')"></audio>
    <audio ref="newRentSound" :src="cdn('beep.mp3')"></audio>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'
  import _ from 'lodash'
  
  export default{
    name: 'QuantityRents',
    components: {},
    data () {
      return {
        rentsStatus: [],
        statusId: this.$route.params.statusId
      }
    },
    computed: {
      apiDomain () {
        return config.apiDomain
      },
      ...mapState({
        user: state => state.user
      })
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'rents_dashboard') {
          this.statusId = parseInt(this.$route.params.statusId)
        }
      }
    },
    mounted () {
      this.getQuantityByStatus()
      this.listenEvents()
    },
    beforeDestroy () {},
    methods: {
      navigate (statusId) {
        this.$router.push({name: 'rents_dashboard', params: {statusId: statusId}})
      },
      playAlertSound () {
        if (this.rentsStatus[1] && this.rentsStatus[1] > 0) {
          // this.$refs.newRents.play()
        }
      },
      setQuantities (data) {
        _.forEach(Object.assign({}, data), (status) => {
          let quantity = parseInt(status.quantity)
          this.$set(this.rentsStatus, parseInt(status.status_id), quantity)
        })
      },
      getQuantityByStatus () {
        this.loadRentsStatusQuantity({ companyId: this.user.company.id })
          .then((response) => {
            this.setQuantities(response.data)
          }, (error) => {
            console.log(error)
          })
      },
      listenEvents () {
        window.Channel.listen('.App\\Events\\DashboardQuantityRents', (e) => {
          this.setQuantities(e)
        })
      },
      ...mapActions(['loadRentsStatusQuantity'])
    }
  }
</script>


// WEBPACK FOOTER //
// QuantityRents.vue?d1bec73c